import React from "react";
import Select from 'react-select';

/* eslint react/prop-types: 0 */
const customStyles = {
    control: base => ({
        ...base,
        minHeight: 16,
        padding: 0,
    }),
    dropdownIndicator: base => ({
        ...base,
        padding: 0,
    }),
    input: base => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
    singleValue: base => ({
        ...base,
        height: '16px',
        color: null,
    }),
};
export class LazySelect extends React.PureComponent {
    state = { options: [{ value: '<loading>', label: 'Loading...' }] };
    ref = React.createRef();

    // // Used to diagnose what's causing a render.
    // componentDidUpdate(prevProps) {
    //     console.log(`${this.props.name}.CellSelect: updated.`);
    //     Object.entries(this.props).forEach(([key, val]) =>
    //         prevProps[key] !== val && console.log(`${this.props.name}.CellSelect: prop '${key}' changed`, prevProps[key], val)
    //     );
    // }

    updateOptions = () => {
        if (this.state.updating) {
            return;
        }
        this.setState({ updating: true });
        Promise.resolve(this.props.options || this.props.getOptions())
            .then(options => {
                this.setState({ updating: false, options }, () => {
                    const valueInOptions = options.find(o => o.value === this.props.value.value);
                    // Scroll to the selected option forcefully.
                    const select = this.ref.current.select;
                    select.scrollToFocusedOptionOnUpdate = true;
                    select.setState({
                        focusedValue: null,
                        focusedOption: valueInOptions,
                    });
                });
            });
    }

    render() {
        const { value, isMulti, onChange } = this.props;
        // console.log(`${this.props.name}.CellSelect: render`, this.props, this.state);
        const valueInOptions = this.state.options.find(o => o.value === value.value);
        return (
            <Select
                ref={this.ref}
                isDisabled={!!this.props.readonly}
                isSearchable
                isMulti={isMulti}
                value={valueInOptions || value}
                options={this.state.options}
                onChange={onChange}
                onFocus={this.updateOptions}
                placeholder={''}
                styles={customStyles}
            />
        );
    }
}

export default class CellSelect extends React.PureComponent {
    render() {
        return (
            <LazySelect
                {...this.props}
                styles={
                    {
                        control: (provided) => (
                            {
                                ...provided,
                                minHeight: 23,
                            }
                        ),
                        valueContainer: (provided) => (
                            {
                                ...provided,
                                padding: "0px 8px",
                            }
                        ),
                        clearIndicator: (provided) => (
                            {
                                ...provided,
                                padding: 0
                            }
                        ),
                        dropdownIndicator: (provided) => (
                            {
                                ...provided,
                                padding: 0
                            }
                        ),
                        input: (provided) => (
                            {
                                ...provided,
                                padding: 0,
                                margin: 0,
                            }
                        ),
                    }
                }
            />
        );
    }
}
